<script>
    import SubMenus from "../SubMenus.vue";
    import SkeletonLoader from '../../../../../components/loaders/SkeletonLoader.vue';

    export default {
        components: {
            SubMenus, SkeletonLoader
        },
        props: {
            isLoading: {
                type: Boolean,
                default: true
            },
            sidebarFolders: {
                type: Array,
                default: () => [],
                required: true,
            },
            dataType: {
                type: String,
                default: 'Own'
            },
            selectedFolderId: {
                type: [Number, String]
            },
            sharedType: {
                type: String,
                default: null
            },
            folderIdsArray: {
                type: Array,
                default: [],
            },
            checkClickEvent: {
                type: Function,
                default: () => {}
            },
            checkRecursiveTreeHasId: {
                type: Function,
                default: () => {}
            },
        }
    }
</script>
<template>
    <div v-if="isLoading" class="row d-flex align-items-center justify-content-center p-2 ps-3">
        <SkeletonLoader/>
    </div>
    <b-collapse
        v-else
        visible
        class="collapse show"
        id="categories-collapse"
    >
        <div class="card border-0 shadow-none ps-2 mb-0">
            <ul class="list-unstyled mb-0 fixedHeightAutoScroll">
                <div v-if="sidebarFolders.length">
                    <template v-for="(item, index) in sidebarFolders">
                        <li v-if="item.hasOwnProperty('docType') && item.docType == 'default'" :key="index">
                            <Link :href="item.viewUrl" class="d-flex align-items-center" :class="{'text-info': dataType == 'Shared' ? (item.id == selectedFolderId && item.docType == sharedType) : item.id == selectedFolderId}">
                                <i class="mdi-folder mdi mdi-file-document font-size-16 me-2" :class="dataType == 'Own' ? 'text-warning' : 'text-primary'"></i>
                                <span :class="{'fixedWidthText': item.name.length > 11}" class="me-auto text-break">
                                    {{ item.name }}
                                </span>
                            </Link>
                        </li>
                        <li v-else-if="(item.hasOwnProperty('totalFolders') && item.totalFolders > 0) || (item.hasOwnProperty('recursive_tree') && item.recursive_tree.length)" :key="index">
                            <div class="custom-accordion">
                                <Link @click.stop.prevent="checkClickEvent(item, $event)" href="javascript:void(0)"
                                    class="text-body fw-medium py-1 d-flex align-items-center"
                                    data-toggle="collapse"
                                    v-b-toggle = "'categories-collapse' + item.id"
                                    role="button"
                                    aria-expanded="false"
                                    :aria-controls="'categories-collapse' + item.id"
                                >
                                    <span
                                        class="d-flex align-items-center gap-1" :class="{'text-info': dataType == 'Shared' ? (item.id == selectedFolderId && item.docType == sharedType) : item.id == selectedFolderId}"
                                    >
                                        <i class="mdi-folder mdi mdi-file-document font-size-16 me-2" :class="dataType == 'Own' ? 'text-warning' : 'text-primary'"></i>                              
                                        <div :class="{'fixedWidthText': item.name.length > 11}" class="text-break" @click="checkClickEvent(item, $event, 1)">{{ item.name.length > 20 ? `${item.name.substring(0, 20).concat('  ...')}` : item.name }}</div> 
                                        <i v-if="((('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword))" class="mdi mdi-lock text-secondary"></i>
                                    </span>
                                    <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                                </Link>
                                <b-collapse
                                    :visible="checkRecursiveTreeHasId(item)"
                                    class="collapse"
                                    :class="{'show': checkRecursiveTreeHasId(item)}"
                                    :id="'categories-collapse' + item.id"
                                >
                                    <div v-if="item.hasOwnProperty('recursive_tree') && item.recursive_tree.length" class="card border-0 shadow-none ps-2 mb-0">                                   
                                        <SubMenus
                                            :sidebarFolders="item.recursive_tree"
                                            :folderIdsArray="folderIdsArray"
                                            :selectedFolderId="selectedFolderId"
                                            :dataType="dataType"
                                            :clickEventFunc="checkClickEvent"
                                            :checkRecursiveTreeHasId="checkRecursiveTreeHasId"
                                            :sharedType="sharedType"
                                        />
                                    </div>
                                </b-collapse>
                            </div>
                        </li>
                        <li v-else :key="index">
                            <Link @click.stop.prevent="checkClickEvent(item, $event)" href="javascript:void(0)" :disabled="true" class="d-flex align-items-center" :class="{'text-info': dataType == 'Shared' ? (item.id == selectedFolderId && item.docType == sharedType) : item.id == selectedFolderId}">
                                <span class="d-flex align-items-center gap-1">
                                    <i class="mdi-folder mdi mdi-file-document font-size-16 me-2" :class="dataType == 'Own' ? 'text-warning' : 'text-primary'"></i>
                                    <div :class="{'fixedWidthText': item.name.length > 11}" class="text-break" @click="checkClickEvent(item, $event, 1)">{{ item.name.length > 20 ? `${item.name.substring(0, 20).concat('  ...')}` : item.name }}</div> 
                                    <i v-if="((('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword))" class="mdi mdi-lock text-secondary"></i>
                                </span>
                            </Link>
                        </li>
                    </template>
                </div>
                <div v-else>
                    <span v-if="dataType === 'Own'" class="me-auto mt-2">No Folders Available.</span>
                    <span v-else class="me-auto mt-2">No Shared Folders Available.</span>
                </div>                                        
            </ul>
        </div>
    </b-collapse>
</template>